import React from "react";

interface CustomerContactCardProps {
  phone?: string;
  showOptions: boolean;
  onToggle: () => void;
  t: (key: string) => string;
  formatPhoneForWhatsApp: (phone: string) => string;
  getWhatsAppMessage: () => string;
}

const CustomerContactCard: React.FC<CustomerContactCardProps> = ({
  phone,
  showOptions,
  onToggle,
  t,
  formatPhoneForWhatsApp,
  getWhatsAppMessage,
}) => {
  if (!phone) return null;

  return (
    <div className="mb-6 bg-gradient-to-r from-purple-50 to-pink-50 p-5 rounded-xl border border-purple-100 shadow-sm">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-xl font-semibold text-gray-800 flex items-center gap-2">
          <span className="text-purple-500">📞</span>
          {t("order.customerContact")}
        </h3>
        <button
          onClick={onToggle}
          className="flex items-center gap-2 px-4 py-2 text-sm bg-purple-100 hover:bg-purple-200 text-purple-700 rounded-lg transition-colors"
        >
          {showOptions ? t("common.hide") : t("common.showContact")}
          <svg
            className={`w-4 h-4 transform ${showOptions ? "rotate-180" : ""}`}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M19 9l-7 7-7-7"
            />
          </svg>
        </button>
      </div>

      {showOptions && (
        <div className="space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            <a
              href={`tel:${phone}`}
              className="flex items-center justify-center gap-3 px-4 py-3 bg-green-500 hover:bg-green-600 text-white rounded-xl transition-colors font-medium"
            >
              📞 {t("order.callCustomer")}
            </a>

            <a
              href={`https://wa.me/${formatPhoneForWhatsApp(phone)}?text=${getWhatsAppMessage()}`}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center gap-3 px-4 py-3 bg-green-600 hover:bg-green-700 text-white rounded-xl transition-colors font-medium"
            >
              💬 {t("order.messageOnWhatsApp")}
            </a>
          </div>

          <div className="mt-4 p-3 bg-gray-50 rounded-lg">
            <p className="text-sm text-gray-600">
              <span className="font-medium">{t("order.phoneNumber")}:</span>{" "}
              {phone}
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default CustomerContactCard;